/**
 * Search bar
 */
export default function searchBar() {
    $(document).on('click', '.search-button .btn', function() {
        $('.search-button .btn').toggleClass('d-none');
        const searchBar = $('.search-bar')
        searchBar.toggleClass('d-none');
        if (!searchBar.hasClass('d-none')) {
            document.getElementById("searchQueryInput").focus();
        }
    });

    $(document).on('click', '.tech-search', function() {
        $(this).closest('form').submit();
    });
}
